<div class="my-account-primary-container">
  <a href="{{ redirectLink }}">
    <img
      class="user-cancelation-logo"
      src="assets/img/universia-white.svg"
      alt="Logo Universia"
    />
  </a>

  <div class="user-cancelation-container">
    <h1 class="user-cancelation-title">
      {{ 'cancelation-user.title' | translate }} {{ user?.firstName }}
    </h1>
    <p class="user-cancelation-text">
      {{ 'cancelation-user.description' | translate }}
    </p>
    <p class="user-cancelation-text--final">
      {{ 'cancelation-user.final-text' | translate }}
    </p>
    <div class="user-cancelation-button-container">
      <a class="my-account-primary-button" href="{{ redirectLink }}">{{
        'cancelation-user.go-to' | translate
      }}</a>
    </div>
  </div>
</div>
